/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the RefreshTokenRequest interface.
 */
// @ts-ignore
export function instanceOfRefreshTokenRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "refreshToken" in value;

    return isInstance;
}

// @ts-ignore
export function RefreshTokenRequestFromJSON(json: any): RefreshTokenRequest {
    return RefreshTokenRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function RefreshTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refreshToken': json['refresh_token'],
    };
}

// @ts-ignore
export function RefreshTokenRequestToJSON(value?: RefreshTokenRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refresh_token': value.refreshToken,
    };
}

